<template lang="pug">
  .container-fluid
    .row.no-gutter
      .d-none.d-md-flex.col-md-4.col-lg-6.bg-image
      .col-md-8.col-lg-6.bg-white
        .login.d-flex.align-items-center.py-5
          .container
            .row
              .col-md-9.col-lg-8.mx-auto
                .my-5
                  // Team Logo
                  img#logo.mx-auto.d-block(src='https://upload.wikimedia.org/wikipedia/en/thumb/a/a7/Paris_Saint-Germain_F.C..svg/1024px-Paris_Saint-Germain_F.C..svg.png' style="height:15vh")
                  .text-uppercase.text-dark.text-center.mt-2(style="font-family: 'Bungee Inline', cursive; font-size:4vh") Fanfest
                
                // Watch / Go Live
                div(v-if='!showLogin')
                  button.btn.btn-lg.btn-primary.btn-block.btn-login.text-white.text-uppercase.font-weight-bold(@click="openWatch" type='button') Watch FanFest
                  .text-center.mb-4 Join 53241 PSG fans inside
                  button.btn.btn-lg.btn-danger.btn-block.btn-login.text-white.text-uppercase.font-weight-bold(@click="showLogin = true" type='button') Join fanfest
                  .text-center.mb-5 Go live during today's event
                
                // Sponsor
                .my-5(v-if='!showLogin')
                  // Team Logo
                  .text-dark.text-center Sponsored By
                  img#logo.mx-auto.d-block(src='https://all.accor.com/assets/images/logo/logo.svg' style="height:10vh")

                  // Go Live Login
                form(v-if='showLogin')
                  .form-label-group.mt-5
                    input#inputUsername.form-control(v-model.trim="username" type='text', placeholder='', required='', autofocus='' autocomplete='username')
                    label(for='inputUsername') First Name
                  .form-label-group
                    input#inputPassword.form-control(v-model.trim="password" type='password', placeholder="", required='' autocomplete='current-password')
                    label(for='inputPassword') Access Code
                  button#buttonLogin.btn.btn-lg.btn-danger.btn-block.btn-login.text-uppercase.font-weight-bold.mb-5(@click="login" type='submit') Enter FanFest    

                // Register(v-if='showLogin')
                div(v-if='showLogin')
                  .mt-5.mb-2
                    .text-center.text-muted Don't have access code? 
                    .text-center.text-muted Request one below. 
                  form(v-if='showLogin')
                    .form-label-group
                      input.form-control(v-model.trim="email" type='text', placeholder='', required='', autofocus='' autocomplete='username')
                      label(for='inputUsername') Email
                  button#buttonLogin.btn.btn-lg.btn-dark.btn-block.btn-login.text-uppercase.font-weight-bold.mb-5(@click="requestAccess" type='submit') Request Access 
</template>

<script>
import Parse from "../services/parse.js";
import axios from "axios";
import bowser from "bowser";

export default {
  name: "login",
  metaInfo() {
    return {
      title: "PSG FanFest Login"
    };
  },
  data() {
    return {
      username: "",
      password: "",
      email: "",
      config: {},
      code: null,
      codeHost: null,
      showLogin: false,
      loggedIn: false,
      urlFanFest: ""
    };
  },
  components: {},
  watch: {
    showLogin: function() {
      const browser = bowser.getParser(window.navigator.userAgent);      
      if(browser.getBrowserName() != 'Chrome' || browser.getPlatformType() != 'desktop')
        this.$router.push({ name: 'client-error' });
    }
  },
  methods: {
    login: async function(event) {
      event.preventDefault();

      const browser = bowser.getParser(window.navigator.userAgent);      
      if(browser.getBrowserName() != 'Chrome' || browser.getPlatformType() != 'desktop') {
        alert("For best streaming performance, FanFest requires Chrome browser on your laptop to go live.");
        return;
      }

      if (this.password != this.code && this.password != this.codeHost) {
        alert("Access code denied / Code d'Accès refusé");
        return;
      }

      var name = this.username.toLowerCase().split(" ")[0];
      this.username = name
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      // this.loggedIn = true;

      axios
        .post(`${process.env.VUE_APP_BACKEND}/app/live/login`, {
          name: this.username,
          code: this.password.trim()
        })
        .then(response => {
          console.log(response);
          this.openWatch();          
        })
        .catch(err => Promise.reject(err.message));
    },
    /* configureWindows: function() {
      this.openLive();
      this.openWatch();
    },
    openLive: function() {
      const options =
        "width=450,height=250,left=800,location=no,menubar=no,status=no,resizable=no";
      const url = window.location;
      const urlNext = `${url.protocol}//${url.host}/user/${this.username}/live`;

      window.open(urlNext, "_blank", options);
    }, */
    openWatch: function() {
      /* const options = "width=1000,height=570,location=no,menubar=no,status=no";
      const url = window.location;
      const urlNext = `${url.protocol}//${url.host}/tbLEDYmsSS?u=${this.username}&c=${this.code}`;
      window.open(urlNext, "_blank", options); */
      var path = '/tbLEDYmsSS'
      if (this.username && this.password)
        path = `${path}?u=${this.username}&c=${this.password}`
      this.$router.push({path:path})
    },
    requestAccess: function() {
      console.log('Sending email...')
      // toggle button color to green for success
      window.location.reload();
    }
  },
  created: async function() {
    this.config = await Parse.Config.get();
    this.code = this.config.get("kFanFestCode");
    this.codeHost = this.config.get("kFanFestCodeHost");
  }
};
</script>

<style>
:root {
  --input-padding-x: 1.5rem;
  --input-padding-y: 0.75rem;
}

.login,
.image {
  min-height: 100vh;
}

.bg-image {
  background-image: url("https://pbs.twimg.com/media/ES5zTgBXQAAwORi?format=jpg&name=medium");
  background-size: cover;
  background-position: center;
}

.login-heading {
  font-weight: 300;
}

.btn-login {
  font-size: 0.9rem;
  letter-spacing: 0.05rem;
  padding: 0.75rem 1rem;
  border-radius: 2rem;
}

.form-label-group {
  position: relative;
  margin-bottom: 1rem;
}

.form-label-group > input,
.form-label-group > label {
  padding: var(--input-padding-y) var(--input-padding-x);
  height: auto;
  border-radius: 2rem;
}

.form-label-group > label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0;
  /* Override default `<label>` margin */
  line-height: 1.5;
  color: #495057;
  cursor: text;
  /* Match the input under the label */
  border: 1px solid transparent;
  border-radius: 0.25rem;
  transition: all 0.1s ease-in-out;
}

.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));
  padding-bottom: calc(var(--input-padding-y) / 3);
}

.form-label-group input:not(:placeholder-shown) ~ label {
  padding-top: calc(var(--input-padding-y) / 3);
  padding-bottom: calc(var(--input-padding-y) / 3);
  font-size: 12px;
  color: #777;
}

/* Fallback for Edge
-------------------------------------------------- */

@supports (-ms-ime-align: auto) {
  .form-label-group > label {
    display: none;
  }
  .form-label-group input::-ms-input-placeholder {
    color: #777;
  }
}

/* Fallback for IE
-------------------------------------------------- */

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .form-label-group > label {
    display: none;
  }
  .form-label-group input:-ms-input-placeholder {
    color: #777;
  }
}
</style>